import { ModelBase, observable } from "@shoothill/core";
import { action } from "mobx";
import { DesignDataFormFileModel } from "../../Forms/DesignDataFormFileModel";
export class DesignDataFileModel extends ModelBase<DesignDataFileModel> {
    public static readonly DEFAULT_DESIGNDATA_ID = "";

    @observable
    public designDataId: string = DesignDataFileModel.DEFAULT_DESIGNDATA_ID;

    @observable
    public designDataFiles: DesignDataFormFileModel[] = [];

    @action
    public fromDto(dto: DesignDataFileResponseDTO): void {
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else if (key === "designDataItems") {
                    // Do nothing.
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    @action
    toDto(model: DesignDataFileModel): void {}
}

export interface DesignDataFileResponseDTO {
    designDataFiles: DesignDataFormFileModel[];
}

export interface DesignDataFileRequestDTO {
    id: string | null;
}
